import React from "react";
import { aud } from "../ui";
import { VerdictPill } from "./parts";

export function PricingTable({ lines, concerns }) {
  if (!lines?.length) return <p className="text-xs text-neutral-500">No repair lines were found on the repair order.</p>;
  const byIdx = Object.fromEntries((concerns || []).map((c) => [c.index, c.concern]));
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs" data-testid="wi-assess-pricing">
        <thead className="text-[0.6rem] uppercase tracking-wider text-neutral-500 text-left">
          <tr className="border-b border-neutral-800"><th className="py-2 pr-3">Repair line</th><th className="py-2 pr-3 text-right">Claimed (ex GST)</th>
            <th className="py-2 pr-3 text-right">Historical avg</th><th className="py-2 pr-3 text-right">±range</th><th className="py-2">Verdict</th></tr>
        </thead>
        <tbody>
          {lines.map((l, i) => (
            <tr key={l.line_id} className="border-b border-neutral-900 align-top">
              <td className="py-2 pr-3">
                <div className="text-neutral-200">{l.standardised_description || l.description}</div>
                <div className="text-neutral-600">{l.component} · {l.line_type?.replace(/_/g, " ")}{l.qty > 1 ? ` · per unit ×${l.qty}` : ""}</div>
                {byIdx[i] && <div className="text-amber-300/90 mt-0.5">AI: {byIdx[i]}</div>}
              </td>
              <td className="py-2 pr-3 text-right tabular-nums text-neutral-200">{aud(l.unit_ex_gst, 2)}</td>
              <td className="py-2 pr-3 text-right tabular-nums text-neutral-400">{aud(l.benchmark?.mean, 2)}{l.benchmark?.n ? <div className="text-neutral-600">{l.benchmark.n} repairs{l.benchmark.match === "similar" ? " · similar" : ""}</div> : null}</td>
              <td className="py-2 pr-3 text-right tabular-nums text-neutral-500 whitespace-nowrap">{l.benchmark?.low ? `${aud(l.benchmark.low)}–${aud(l.benchmark.high)}` : "—"}</td>
              <td className="py-2"><VerdictPill verdict={l.verdict} diff={l.diff_pct} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
